import React, { Component } from "react";
import { Grid, Header, Divider } from 'semantic-ui-react'
import HomeWelcome from './HomeWelcome'
import HomeForm from './HomeForm'

export default class Home extends Component {
  render() {
    return (
      <>
        <Header as="h1" textAlign="center">Welcome to the Phykraun Repository</Header>
        <Divider section />
        <Grid stackable columns={2} divided='vertically'>
          <Grid.Row>
            <Grid.Column>
              <HomeWelcome />
            </Grid.Column>
            <Grid.Column>
              <HomeForm />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}